// extracted by mini-css-extract-plugin
export var labelWrapper = "_m0-0";